import i18nDE from './de';
import i18nEN from './en';

export default {
  en: i18nEN,
  de: i18nDE,
};
